import { useCallback } from 'react';
import { useSnackbar } from '@emburse/embark-core';
import useLoadingOverlay from '../hooks/useLoadingOverlay';
/**
 * Provides standardized snackbar and error handling for async operations.
 * Returns: [snackbarHandler, errorHandler]
 */
const useSnackbarHandler = () => {
    const { enqueueSnackbar } = useSnackbar();
    const { removeLoadingState } = useLoadingOverlay();
    const snackbarHandler = useCallback((message, severity) => {
        enqueueSnackbar(message, { variant: 'alert', AlertProps: { severity } });
    }, [enqueueSnackbar]);
    const errorHandler = useCallback((err) => {
        removeLoadingState();
        snackbarHandler(err?.Message || err, 'error');
    }, [removeLoadingState, snackbarHandler]);
    return { snackbarHandler, errorHandler };
};
export default useSnackbarHandler;
